import { Injectable } from '@angular/core';
import {
  AllDocumentsResponse,
  CallbackPayload,
  DocumentApiResponse,
  DocumentFile,
  DocumentFileTypeItem,
  DocumentUploadPayload,
} from '@modules/documents/documents.interface';
import { DocumentsResource } from '@modules/documents/services/documents.resource';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(private resource: DocumentsResource) {}

  public getNeeded(): Observable<DocumentFileTypeItem[]> {
    return this.resource.getNeeded().pipe(map(i => i.fileTypes));
  }

  public getAllDocuments(): Observable<AllDocumentsResponse> {
    return this.resource.getUploaded();
  }

  public upload(payload: DocumentUploadPayload): Observable<string> {
    return this.resource.upload(payload).pipe(map(i => i.fileId));
  }

  public getOne(fileId: string): Observable<DocumentFile> {
    return this.resource.getOne(fileId).pipe(
      map(i => {
        const updatedFile = {
          ...i.file,
          mimetype: i.file.mimetype.toLowerCase(),
        };
        return updatedFile;
      })
    );
  }

  public delete(fileId: string): Observable<DocumentApiResponse> {
    return this.resource.delete(fileId);
  }

  public sign(fileId: string): Observable<DocumentApiResponse> {
    return this.resource.sign(fileId);
  }

  public callback(payload: CallbackPayload): Observable<DocumentApiResponse> {
    return this.resource.callback(payload);
  }
}
